import type { Breakpoint } from "@mui/material/styles";

import { Container, ContainerProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { layoutClasses } from "app/layout/settings";

export type MainLayoutContainerProps = ContainerProps & {
  disablePadding?: boolean;
};

export const MainLayoutContainer = ({
  children,
  disablePadding,
  maxWidth = "xl",
  sx,
  ...other
}: MainLayoutContainerProps) => {
  const theme = useTheme();

  const layoutQuery: Breakpoint = "lg";

  return (
    <Container
      className={layoutClasses.content}
      maxWidth={maxWidth || false}
      sx={{
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        pb: "var(--layout-dashboard-content-pb)",
        pt: "var(--layout-dashboard-content-pt)",
        [theme.breakpoints.up(layoutQuery)]: {
          px: "var(--layout-dashboard-content-px)",
        },
        ...(disablePadding && {
          p: {
            lg: 0,
            md: 0,
            sm: 0,
            xl: 0,
            xs: 0,
          },
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Container>
  );
};
